export default __webpack_public_path__ + "e76df88a7ed04a5cb51f5161c3db84d1.png";